import React from 'react';

const About = () => {
  return (
    <div className="aboutPage">
      <h1>About Us</h1>
      <p>
        Welcome to our e-commerce platform! We are dedicated to providing you with the best shopping experience possible. 
        Our mission is to offer high-quality products at affordable prices, ensuring customer satisfaction every step of the way.
      </p>
      <p>
        Our team works tirelessly to curate a wide range of products to meet your needs. Whether you're looking for the latest 
        gadgets, stylish apparel, or everyday essentials, we've got you covered.
      </p>
      <p>
        Our team works tirelessly to curate a wide range of products to meet your needs. Whether you're looking for the latest 
        gadgets, stylish apparel, or everyday essentials, we've got you covered.
      </p>
      <br />
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut nobis illum ex ab reiciendis fugit vero iste ipsum, cum libero porro, nam optio repudiandae minima. Amet exercitationem modi cumque molestias labore numquam voluptate laborum voluptatum omnis repellat adipisci nisi porro perspiciatis itaque, </p>

      
      <p>
        Thank you for choosing us. We look forward to serving you!
      </p>
    </div>
  );
};

export default About;